export default __webpack_public_path__ + "static/enable-session-replay-in-project-settings-f07b90ac8f918accad6d52d913df83f2.png";